(function ($) {
    $(document).ready(function () {
        if ($('.js-form-dashboard').length) {
            var $form = RISSB.fn.ajaxForm({
                form: '.js-form-dashboard',
                clearForm: false,
                beforeSubmitCb: function () {
                    RISSB.fn.clearAlert();
                },
                successCb: function (res) {
                    RISSB.fn.showAlert(res.data.msg, 'success');
                },
                errorCb: function () {
                    if ($('.accordion-content').length) {
                        $('.invalid-feedback').closest('fieldset').find('.accordion-content').collapse('show');
                    }
                }
            });
        }
    });
})(jQuery);

